<script lang="ts" module>
  import { reactiveContext } from "#lib"

  const defaults = {
    open: false,
  }

  const { setContext, getContext } = reactiveContext(defaults)
  export const getTooltipRootCtx = getContext
</script>

<script lang="ts">
  import { Tooltip, type TooltipRootProps } from "#lib/internal/components"
  import type { Snippet } from "svelte"

  type Props = TooltipRootProps & {
    children?: Snippet
  }

  let {
    open = $bindable(defaults.open),
    delayDuration = 300,
    disableHoverableContent = false,
    children,
    ...restProps
  }: Props = $props()

  const ctx = setContext({
    open: (v) => {
      if (v !== open) open = v
    },
  })

  $effect(() => {
    ctx.update((state) => ({ ...state, open }))
  })
</script>

<Tooltip.Root
  bind:open
  {delayDuration}
  {disableHoverableContent}
  {...restProps}
>
  {@render children?.()}
</Tooltip.Root>
